// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".createPlaylist_item__2FgTX {\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  height: 30px;\n  color: #464646;\n  border-bottom: 1px solid #e0e0e0;\n  width: 70px;\n  text-align: left;\n  display: flex;\n  align-items: center; }\n\n.createPlaylist_input__2Fi5b {\n  padding-left: 20px; }\n\n.createPlaylist_btn__3M3Wr {\n  background: inherit;\n  height: auto;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n  width: auto; }\n", ""]);
// Exports
exports.locals = {
	"item": "createPlaylist_item__2FgTX",
	"input": "createPlaylist_input__2Fi5b",
	"btn": "createPlaylist_btn__3M3Wr"
};
module.exports = exports;
